var productMixin = {

    methods: {

        hasDiscount: function(discount) {
            var isNotUndefined = (typeof(discount) !== "undefined");
            var isNotNull = (discount !== null);

            if (isNotUndefined && isNotNull) {
                if (discount.isValid === 'true') {
                    return true
                }
            }

            return false
        },

        includeDiscountSavings: function(financing) {
            let updatedValues = {}

            if(this.hasDiscount(financing.discount)) {
                let discountRate = Math.round(financing.discount.discount * 100)
                let savings = financing.monthlyInstallment - financing.finalMonthlyInstallment

                updatedValues = {
                    discountRate: discountRate,
                    savings: savings
                }
            }

            return { ...financing, ...updatedValues }
        },

        startCheckoutProcess: function(params) {

            if (this.$root.isPublicSession()) {
                this.$root.openModal('modal_notice_no_auth', {id: params.productId})
                return false
            } else {
                let details = this.$store.state.session.noticeDetails
                if ((_.get(details, 'checkout_priority', false)) && (_.get(params, 'gposChangeItem', '') !== true && _.get(params, 'gposClaiming', '') !== true)) {
                    this.$root.openModal(details.modal, {...details.data, ...{productForCheckout: params.productId}})
                    return false
                } else {
                    if (this.$store.state.session.canCheckout || this.$store.state.session.canGenPos) {
                        this.$router.push({
                            name: 'checkout',
                            query: {
                                id: params.productId,
                                mid: _.get(params, 'checkoutDetails.merchantId', ''),
                                genpos: _.get(params, 'genPos', 'false'),
                                inCheckout: 'customer_selection',
                                source: _.get(params, 'source', ''),
                                gposChangeItem: _.get(params, 'gposChangeItem', ''),
                                gposPreapproved: _.get(params, 'gposPreapproved', ''),
                                gposClaiming: _.get(params, 'gposClaiming', ''),
                                outsidePreapproved: _.get(params, 'outsidePreapproved', ''),
                                camid: _.get(params, 'campaignId', ''),
                            }
                        })
                    } else {
                        let details = this.$store.state.session.noticeDetails
                        this.$root.openModal(details.modal, details.data)
                    }
                }
                // if (this.$store.state.session.canCheckout) {
                //     this.$root.openModal('modal_checkout', params)
                // } else if (this.$store.state.session.canGenPos) {
                //     this.$root.openModal('modal_pos_offer', {product: params.product, merchant: _.get(params, 'merchant', null)})
                // } else {
                //     let details = this.$store.state.session.noticeDetails
                //     this.$root.openModal(details.modal, details.data)
                // }
            }
        },
    }
}

export default productMixin
